<template>
    <iframe class="iframe-address" :src="src" frameborder="0" scrolling="no" allowtransparency="true" aria-label="The Frame" name="Frame"></iframe>
</template>

<script>
    export default {
        name: 'BasicFrame',
        props: {
            src: { type: String, required: true },
        },
        data() {
            return {};
        },
    }
</script>
